/*
 * Demo content for FabricJS.
 */


const demoContent = (canvas, fabric) => {
 
  const tboxfront = new fabric.Textbox('Front', {
    left: 150, top: 20, width: 130, fontSize: 20, fontFamily: "'Open Sans', sans-serif"
  })
  tboxfront.setSelectionStyles({ fontWeight: 'bold'}, 0, 50)
  tboxfront.setSelectionStyles({ fontFamily: 'Impact', fill: 'red' }, 18, 21)
  tboxfront.setControlsVisibility({ 'mb': false })
  canvas.add(tboxfront)

  const tboxleft = new fabric.Textbox('Left', {
    left: 510, top: 20, width: 130, fontSize: 20, fontFamily: "'Open Sans', sans-serif"
  })
  tboxleft.setSelectionStyles({ fontWeight: 'bold' }, 0, 50)
  tboxleft.setSelectionStyles({ fontFamily: 'Impact', fill: 'red' }, 18, 21)
  tboxleft.setControlsVisibility({ 'mb': false })
  canvas.add(tboxleft)

  const tboxtop = new fabric.Textbox('Top', {
    left: 900, top: 20, width: 130, fontSize: 20, fontFamily: "'Open Sans', sans-serif"
  })
  tboxtop.setSelectionStyles({ fontWeight: 'bold' }, 0, 50)
  tboxtop.setSelectionStyles({ fontFamily: 'Impact', fill: 'red' }, 18, 21)
  tboxtop.setControlsVisibility({ 'mb': false })
  canvas.add(tboxtop)

  const tboxback = new fabric.Textbox('Back', {
    left: 150, top: 390, width: 130, fontSize: 20, fontFamily: "'Open Sans', sans-serif"
  })
  tboxback.setSelectionStyles({ fontWeight: 'bold' }, 0, 50)
  tboxback.setSelectionStyles({ fontFamily: 'Impact', fill: 'red' }, 18, 21)
  tboxback.setControlsVisibility({ 'mb': false })
  canvas.add(tboxback)

  const tboxright = new fabric.Textbox('Right', {
    left: 510, top: 390, width: 130, fontSize: 20, fontFamily: "'Open Sans', sans-serif"
  })
  tboxright.setSelectionStyles({ fontWeight: 'bold' }, 0, 50)
  tboxright.setSelectionStyles({ fontFamily: 'Impact', fill: 'red' }, 18, 21)
  tboxright.setControlsVisibility({ 'mb': false })
  canvas.add(tboxright)

  const tboxbottom = new fabric.Textbox('Bottom', {
    left: 900, top: 390, width: 130, fontSize: 20, fontFamily: "'Open Sans', sans-serif"
  })
  tboxbottom.setSelectionStyles({ fontWeight: 'bold' }, 0, 50)
  tboxbottom.setSelectionStyles({ fontFamily: 'Impact', fill: 'red' }, 18, 21)
  tboxbottom.setControlsVisibility({ 'mb': false })
  canvas.add(tboxbottom)

  // fabric.Image.fromURL(require('../default-images/mesh basket.11.png'), function(oImg) {
  //   oImg.set({ left: 90, top: 60,scaleX: 150 / oImg.width,
  //       scaleY: 150 / oImg.height })
  //   canvas.add(oImg);
  // }, { crossOrigin: 'Anonymous' });

  // fabric.Image.fromURL(require('../default-images/mesh basket.17.png'), function(oImg) {
  //   oImg.set({ left: 400, top: 60,scaleX: 150 / oImg.width,
  //       scaleY: 150 / oImg.height })
  //   canvas.add(oImg);
  // }, { crossOrigin: 'Anonymous' });


  // fabric.loadSVGFromURL('test.svg', function(objects) {
  //   const obj = fabric.util.groupSVGElements(objects);
  //   obj.set({ left: 230, top: 190 });
  //   canvas.add(obj).renderAll();
  // });

}


export default demoContent
